import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const OrderSummaryContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      {...props}
      style={[
        styles.orderSummaryContainer,
        isDesktop && styles.orderSummaryContainerDesktop,
        style,
      ]}
    />
  );
};

const styles = StyleSheet.create({
  orderSummaryContainer: {
    marginTop: 16,
    width: '100%',
  },
  orderSummaryContainerDesktop: {
    marginTop: 32,
  },
});
